(() => {
  'use strict';
  if (window.vercettoInitialized) return;
  window.vercettoInitialized = true;
  let lastFocus = null;
  const closeMenus = () => document.querySelectorAll('[data-vc-menu]').forEach(button => {
    button.setAttribute('aria-expanded', 'false');
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (panel) panel.hidden = true;
  });
  const closeModal = dialog => {
    if (dialog && dialog.open) dialog.close();
    document.body.classList.remove('vc-modal-open');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  };
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const detailButton = target.closest('[data-vc-open-details]');
    if (detailButton) {
      const detail = document.getElementById(detailButton.dataset.vcOpenDetails);
      if (detail instanceof HTMLDetailsElement) {
        detail.open = true;
        const summary = detail.querySelector('summary');
        if (summary) summary.focus({ preventScroll: true });
        detail.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      return;
    }
    const opener = target.closest('[data-vc-dialog]');
    if (opener) {
      event.preventDefault(); closeMenus();
      const dialog = document.getElementById(opener.dataset.vcDialog);
      if (dialog) {
        lastFocus = opener; dialog.showModal(); document.body.classList.add('vc-modal-open');
        const input = dialog.querySelector('input'); if (input) input.focus();
      }
      return;
    }
    const closer = target.closest('[data-vc-close]');
    if (closer) { closeModal(closer.closest('dialog')); return; }
    const menu = target.closest('[data-vc-menu]');
    if (menu) {
      const panel = document.getElementById(menu.getAttribute('aria-controls'));
      if (panel) {
        const open = menu.getAttribute('aria-expanded') !== 'true';
        menu.setAttribute('aria-expanded', String(open)); panel.hidden = !open;
      }
      return;
    }
    const thumb = target.closest('[data-vc-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-vc-gallery]');
      const main = gallery && gallery.querySelector('[data-vc-main]');
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt || '';
      if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
      gallery.querySelectorAll('[data-vc-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      return;
    }
    const dialogLink = target.closest('dialog a[href]');
    if (dialogLink) closeModal(dialogLink.closest('dialog'));
    if (target.closest('.vc-mobile-menu a,.vc-mobile-menu button')) closeMenus();
    if (target.tagName === 'DIALOG') {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeModal(target);
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('dialog[open]').forEach(closeModal); closeMenus();
    }
  });
  document.addEventListener('cancel', event => {
    if (event.target.tagName === 'DIALOG') document.body.classList.remove('vc-modal-open');
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-vc-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type=submit]');
    const status = form.querySelector('[role=status]');
    if (!button || button.disabled || !status) return;
    const text = button.textContent;
    button.disabled = true; button.textContent = 'Añadiendo…'; status.textContent = ''; status.dataset.error = 'false';
    try {
      const response = await fetch(form.action + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'No se pudo añadir el reloj. Inténtalo de nuevo.');
      window.location.assign(form.dataset.cartUrl || '/cart');
    } catch (error) {
      status.textContent = error.message || 'No se pudo conectar. Inténtalo de nuevo.';
      status.dataset.error = 'true'; button.disabled = false; button.textContent = text;
    }
  });
})();
